/*********************************************************
 * Override this file with customer implementation to   *
 * customize routes. This shoule mainly entail adding a *
 * completely individual route for a customer. If a     *
 * specific route that exists in the core needs to be   *
 * customized then the respective routes file should be *
 * replaced                                             *
 *******************************************************/
import core_routes from "@/router/modules/core_routes";

export default core_routes; 
